/** 导出操作统一 loading / 遮罩。创建于 2026-08-29 */

export const EXPORT_LOADING_TEXT = '正在导出，请稍候...'

const exportStateKeys = [
  'exportLoading',
  'exporting',
  'orderExportLoading',
  'orderListExportLoading',
  'syncLogExportLoading',
  'exportSignInLoading',
  'reportExportLoading',
]

/** 是否为工具栏「导出」类按钮。创建于 2026-08-29 */
export function isExportToolbarButton(item) {
  if (!item) return false
  const name = String(item.name || '')
  const func = String(item.Func || '')
  if (name.indexOf('导出') >= 0) return true
  if (/^export/i.test(func)) return true
  if (func === 'handleExport' || func === 'doExport') return true
  return false
}

/** 是否为导出相关方法名。创建于 2026-08-29 */
export function isExportMethodName(name) {
  const methodName = String(name || '')
  if (methodName === 'handleExport' || methodName === 'doExport') return true
  return /^export/i.test(methodName)
}

/** 同步工具栏导出按钮 loading。创建于 2026-08-29 */
export function setToolbarExportLoading(vm, loading, options = {}) {
  const key = options.buttonListKey || 'buttonList'
  const list = vm[key]
  if (!Array.isArray(list)) return
  list.forEach((btn, index) => {
    if (isExportToolbarButton(btn)) {
      vm.$set(list[index], 'loading', !!loading)
    }
  })
}

function syncExportStateKeys(vm, loading) {
  exportStateKeys.forEach((stateKey) => {
    if (Object.prototype.hasOwnProperty.call(vm, stateKey)) {
      vm[stateKey] = !!loading
    }
  })
}

function createExportOverlay(vm, options = {}) {
  if (!vm.$loading || options.overlay === false) return null
  return vm.$loading({
    lock: true,
    text: options.text || EXPORT_LOADING_TEXT,
    spinner: 'el-icon-loading',
    background: options.background || 'rgba(0, 0, 0, 0.7)',
  })
}

/**
 * 包裹导出异步任务：按钮 loading + 全屏遮罩 + 防重复点击。创建于 2026-08-29
 */
export async function runWithExportLoading(vm, task, options = {}) {
  if (!vm || typeof task !== 'function') return undefined

  vm._exportTaskDepth = (vm._exportTaskDepth || 0) + 1
  const isOuter = vm._exportTaskDepth === 1
  if (!isOuter) {
    try {
      return await task()
    } finally {
      vm._exportTaskDepth -= 1
    }
  }

  if (vm._exportTaskRunning) return undefined
  vm._exportTaskRunning = true

  setToolbarExportLoading(vm, true, options)
  syncExportStateKeys(vm, true)

  const overlay = createExportOverlay(vm, options)
  try {
    return await task()
  } finally {
    if (overlay) overlay.close()
    setToolbarExportLoading(vm, false, options)
    syncExportStateKeys(vm, false)
    vm._exportTaskRunning = false
    vm._exportTaskDepth = 0
  }
}

/** 包装组件 methods 中的导出方法。创建于 2026-08-29 */
export function wrapExportMethod(original) {
  if (!original || original.__withExportLoading) return original
  const wrapped = function exportWithLoadingWrapper(...args) {
    return runWithExportLoading(this, async () => {
      const result = original.apply(this, args)
      if (result && typeof result.then === 'function') {
        return result
      }
      return result
    })
  }
  wrapped.__withExportLoading = true
  return wrapped
}

/** 为组件 options.methods 批量注入导出 loading。创建于 2026-08-29 */
export function patchExportMethods(methods) {
  if (!methods) return
  Object.keys(methods).forEach((methodName) => {
    if (!isExportMethodName(methodName)) return
    methods[methodName] = wrapExportMethod(methods[methodName])
  })
}
